import { useState } from "react";
import { Col, Container, Dropdown, Row } from "react-bootstrap";
import TableLayout from "../../../components/TableLayout";
import { CommonSelect, CstmPagination, CustomAsyncSelect } from "../../../components/Common/Common";
import { CHATTER_EVENT_ATTENDANCE_DETAIL } from "config/paths";
import { useGetChatterProgramAttendanceListQuery } from "store/services/chatterPrograms";
import LoadingIndicator from "components/shared/LoadingIndicator";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingOverlay from "components/shared/LoadingOverlay";
import TableHeader from "components/shared/FormComponents/TableHeader";
import { useLazyProgramLookupQuery } from "store/services/utility";
import { CHATTER_LOCATION_TYPE_OPTIONS, CHATTER_MEMEBER_TPYES, CHATTER_MEMEBER_TYPES } from "config/constants";

const ChatterEventAttendance = () => {

  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [filter, setFilter] = useState({
    search: "",
    status: "active",
    program_id: "",
    location_type: "",
    sort: {
      column: "id",
      direction: "desc"
    }
  });

  const { data, isLoading, isError, isFetching } = useGetChatterProgramAttendanceListQuery({ page: currentPage, limit: pageSize, ...filter, program_id: filter?.program_id?.value, location_type: filter?.location_type?.value });
  const totalRecords = data?.totalRecords || 0;
  const totalPages = Math.ceil(totalRecords / pageSize);

  // School Lookup
  const [getProgramList, { isFetching: programListFetching }] = useLazyProgramLookupQuery();

  const getProgramOptions = async (search) => {
    try {
      const data = await getProgramList(search).unwrap();
      return data?.map(i => ({ label: i.name, value: i.id }))
    } catch (error) {
      console.log("Error Getting school options");
    };
  };

  const column = [
    {
      head: (
        <>
          <div className="d-flex align-items-center gap-10">
            Last Name
          </div>
        </>
      ),
      accessor: "LastName",
      isComponent: true,
      component: (item, ind) => (
        <div className="d-flex align-items-center gap-10">
          <h6 className="m-0 fw-sbold">{item.lastname || "--"}</h6>
        </div>
      ),
    },
    {
      head: "First Name",
      accessor: "FirstName",
      component: (item, ind) => (
        <h6 className="m-0 fw-sbold">{item.firstname || ""}</h6>
      ),
    },
    {
      head: "Present",
      accessor: "total_presents",
      component: (item, ind) => (
        <>{item.total_presents ?? ""}</>
      ),
    },
    {
      head: "Absent",
      accessor: "total_absents",
      component: (item, ind) => (
        <>{item.total_absents ?? ""}</>
      ),
    },
    {
      head: "Total Sessions",
      accessor: "total_session",
    },
    {
      head: "Total Programs",
      accessor: "total_programs",
    },
    {
      head: "Member Type",
      accessor: "total_absents",
      component: (item, ind) => (
        <>
          {item?.client_detail?.client_type === "chatter" ? (
            "Chatter Client"
          ) : item?.client_detail?.client_type === "peer" ? (
            "Chatter Peer"
          ) : null}
        </>
      ),
    },
  ];

  const resetFilter = () => {
    setFilter({ search: "", funding_source: "", status: "active", sort: { column: "id", direction: "desc" } });
    setCurrentPage(1)
  };

  const handleFilterChange = (key) => (value) => {
    setFilter((prevState) => ({
      ...prevState,
      [key]: value,
    }));
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    window.scrollTo(0, 0);
    setCurrentPage(page);
  };

  return (
    <>
      <section className="designations position-relative py-4">
        <Container fluid>
          <Row>
            <Col lg="12" className="my-2">
              <div className="TableFilter d-flex align-items-center justify-content-between gap-10 flex-wrap">
                <div className="left">
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10 flex-wrap">

                    <TableHeader
                      heading={"Chatter Program Attendance"}
                      handleFilterChange={handleFilterChange}
                      filter={filter}
                      resetFilter={resetFilter}
                      searchPlaceholder="Peer / Participant name"
                      filterComponent={
                        <>
                          <li>
                            <CustomAsyncSelect
                              placeholder={"Program Name"}
                              loadOptions={getProgramOptions}
                              onChange={handleFilterChange("program_id")}
                              value={filter?.program_id}
                              defaultOptions={true}
                              isFilter={true}
                            // isClearable
                            />
                          </li>
                          <li>
                            <CommonSelect
                              placeholder={"Location Type"}
                              option={CHATTER_LOCATION_TYPE_OPTIONS}
                              onChange={handleFilterChange("location_type")}
                              value={filter?.location_type}
                              isFilter={true}
                            // isClearable
                            />
                          </li>
                          <li>
                            <CommonSelect
                              placeholder={"Member Type"}
                              option={CHATTER_MEMEBER_TYPES}
                              onChange={handleFilterChange("client_type")}
                              value={filter?.client_type}
                              isFilter={true}
                            // isClearable
                            />
                          </li>
                          {/* <li className="">
                            <Dropdown onSelect={handleFilterChange("client_type")}>
                              <Dropdown.Toggle
                                variant="transparent"
                                className="border-0 d-flex align-items-center  justify-content-center"
                                id="dropdown-basic"
                              >
                                {CHATTER_MEMEBER_TYPES?.find(x => x.value == filter?.client_type)?.label || "Member Type"}
                                <span className="icn ms-2">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="8"
                                    viewBox="0 0 12 8"
                                    fill="none"
                                  >
                                    <path
                                      d="M1.415 0.298828L6 4.731L10.585 0.298828L12 1.66666L6 7.46666L0 1.66666L1.415 0.298828Z"
                                      fill="black"
                                    />
                                  </svg>
                                </span>
                              </Dropdown.Toggle>
                              <Dropdown.Menu >
                                {
                                  !CHATTER_MEMEBER_TYPES?.length ? <Dropdown.Item disabled eventKey={null}>No Record Found</Dropdown.Item> : CHATTER_MEMEBER_TYPES?.map((item, index) => {
                                    return <Dropdown.Item key={index} eventKey={item.value}>{item?.label}</Dropdown.Item>
                                  })
                                }
                              </Dropdown.Menu>
                            </Dropdown>
                          </li> */}
                        </>
                      }
                    />
                  </ul>
                </div>
              </div>
              <div className="table-outer">
                {isLoading ? (
                  <div style={{ height: "200px" }}>
                    <LoadingIndicator />
                  </div>
                ) : isError ? (
                  <ErrorComponent />
                ) : (
                  <>
                    {(isFetching) && <LoadingOverlay />}
                    <TableLayout
                      data={data?.records || []}
                      column={column}
                      handleSort={handleFilterChange("sort")}
                      filter={filter}
                      url={CHATTER_EVENT_ATTENDANCE_DETAIL.replace("/:id", "")}
                    />
                  </>
                )}
                <CstmPagination
                  totalPages={totalPages}
                  activePage={currentPage}
                  handlePageChange={handlePageChange}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ChatterEventAttendance;
